<template>
  <div class="clearfix">
    <div class="f-left">
      <button class="trigger-aside-btn" v-if="navigation.isMini || navigation.isClose" @click="toOpen"><i class="fa fa-indent" aria-hidden="true"></i></button>
      <button class="trigger-aside-btn" v-else @click="toMini"><i class="fa fa-outdent" aria-hidden="true"></i></button>
      <img src="http://i.gtimg.cn/qqlive/images/20170712/logo_gold.svg" alt="logo" class="header-logo am-fade-left">
    </div>

    <div class="f-right">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <avator :avator="userInfo.avator" :type="userInfo.loginType" />&nbsp;
          <span>{{userInfo.nickName}}</span><i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="width: 120px">
          <el-dropdown-item command="logout"><i class="fa fa-sign-out"></i> 退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Avator from './avator'

export default {
  components: { Avator },
  props: {
    navigation: Object
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('user', ['getUserInfo']),
    toMini () {
      this.$emit('update:navigation', {
        ...this.navigation,
        isMini: true,
        width: 60
      })
    },
    toOpen () {
      this.$emit('update:navigation', {
        ...this.navigation,
        isMini: false,
        isClose: false,
        width: this.navigation.oldWidth || 240
      })
    },
    handleCommand (cmd) {
      if (cmd === 'logout') {
        this.$cookie.set('verify_phone_code', 0)
        this.$cookie.set('verify_phone_code_time', 0)
        window.txvLogin && window.txvLogin.logout()
        this.$router.push('/auth')
      }
    }
  },
  created () {
    this.getUserInfo()
  }
}
</script>
